import { Expose, Type } from 'class-transformer';
import {
  ExpenseIncomeStatusEnum,
  TransferAccountTypeEnum,
} from 'common/constants/enum';

// Model

class AccountableModel {
  id: string;
  name: string;
}
export class OtherIncomeModel {
  id: string;
  number: string;
  status: ExpenseIncomeStatusEnum;
  description: string;

  @Expose({ name: 'acknowledged_at' })
  @Type(() => Date)
  acknowledgedAt: Date | null;

  @Expose({ name: 'account_type' })
  accountType: TransferAccountTypeEnum | null;

  @Type(() => AccountableModel)
  accountable: AccountableModel | null;

  @Type(() => Number)
  amount: number;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;
}

// Input

export type getOtherIncomeInput = {
  id: string;
};

export type OtherIncomeMutationInput = {
  transactionAt: Date;
  amount: number;
  acknowledgedAt: Date | null;
  description: string;
  accountType: string | null;
  accountableId: string | null;
};

export type OtherIncomeCreateInput = {
  incomableRefId: string;
  incomableRefType: string;
  otherIncomes: OtherIncomeMutationInput[];
};

export type OtherIncomeUpdateInput = {
  otherIncomeRefId: string;
  body: OtherIncomeMutationInput;
};

export type OtherIncomeVoidInput = {
  otherIncomeRefId: string;
};
